var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$.filter_footers }, [
    _vm.footerType === "footer-main"
      ? _c("div", { class: [_vm.$.footer, _vm.$.footer__main] }, [
          _c(
            "div",
            { class: [_vm.$.button, _vm.$.button__clear] },
            [
              _c("vgp-button", {
                attrs: {
                  id: "gp_autotest_filter_sidebar_clear_filter",
                  label: _vm.locales("filter_sidebar_clear_filter"),
                  type: "secondary",
                  disabled: !_vm.isActive,
                },
                on: {
                  onClick: function ($event) {
                    return _vm.$emit("onResetClick")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                _vm.$.button,
                _vm.$.button__save,
                !_vm.pricingAccess ? "pricing-tooltip" : "",
              ],
              style: { borderRadius: "4px !important" },
              attrs: {
                "data-feature": "saving_filters",
                "data-position": "left",
              },
            },
            [
              _c("vgp-button", {
                attrs: {
                  id: "gp_autotest_filter_sidebar_save_filter",
                  label: _vm.locales("filter_sidebar_save_filter"),
                  "pricing-label": !_vm.pricingAccess
                    ? _vm.locales(_vm.pricingPlan)
                    : null,
                  type: "primary-border",
                  disabled: !_vm.isActive || !_vm.pricingAccess,
                },
                on: {
                  onClick: function ($event) {
                    return _vm.$emit("onSaveClick")
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.footerType === "footer-save"
      ? _c("div", { class: [_vm.$.footer, _vm.$.footer__saving] }, [
          _c(
            "div",
            { class: [_vm.$.button, _vm.$.button__cancel] },
            [
              _c("vgp-button", {
                attrs: {
                  id: "gp_autotest_filter_sidebar_cancel_changes",
                  label: _vm.locales("common_cancel"),
                  type: "secondary",
                  "has-margin": false,
                },
                on: {
                  onClick: function ($event) {
                    return _vm.$emit("onCancelClick")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: [_vm.$.button, _vm.$.button__apply_save] },
            [
              _c("vgp-button", {
                attrs: {
                  id: "gp_autotest_filter_sidebar_apply_changes",
                  label: _vm.locales("common_save"),
                  type: "primary",
                  "has-margin": false,
                },
                on: {
                  onClick: function ($event) {
                    return _vm.$emit("onApplyClick")
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }